import React, { useCallback } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { globalTheme } from "@cld/component-theme";
import { useSelectedAsset, usePurchaseInfo, useProducts } from "../../selectors";
import actions, { types as ats } from "../../actions";
import Plan from "./Plan";
import Format from "./Format";
import Summary from "./Summary";

const PreviewBox = styled.div`
	background: ${globalTheme.palette.surface};
	box-shadow: ${globalTheme.shadow.md};
	flex-grow: 1;
	z-index: 2;
	overflow: auto;
`;
const { [ats.SELECT_PRODUCT]: handleSelectProductAction, [ats.SELECT_ASSETS_FORMAT]: handleSelectAssetFormatAction } = actions.creators;


export default () => {
	const dispatch = useDispatch();
	const { selectedAsset, selectedFormat } = useSelectedAsset();
	const { selectedProduct } = useProducts();
	const { isAssetIncludedInProduct, isAlreadyPurchased } = usePurchaseInfo();

	const handleSelectAssetFormat = useCallback((payload) => {
		dispatch(handleSelectAssetFormatAction(payload));
	}, [dispatch]);

	return (
		<PreviewBox>
			{!isAlreadyPurchased && <Plan selectProduct={handleSelectProductAction} selectedAsset={selectedAsset} />}
			{(isAlreadyPurchased ||
				(selectedProduct?.exceeded === false &&
				isAssetIncludedInProduct &&
				(selectedAsset.creditPrice < selectedProduct?.creditsRemaining &&
				selectedProduct?.type === "creditpack" || selectedProduct?.type !== "creditpack" && selectedProduct.downloadsRemaining > 0))) && (
				<Format selectedAsset={selectedAsset} selectedFormat={selectedFormat} selectAssetFormat={handleSelectAssetFormat} />
			)}
			<Summary selectedAsset={selectedAsset} selectedProduct={selectedProduct}/>
		</PreviewBox>
	);
};

